<div class="col-{{size}} col-lg-{{sizeLg}} col-xl-{{sizeXl}} m-t-4">
  <div class="d-flex">
    <mat-label class="f-w-500 d-block flex-grow-1" style="line-height: 14px;" *ngIf="label">{{label}} <span class="required" *ngIf="required">*</span></mat-label>
    <div class="flex-grow-0 flex-shrink-0">
      <ng-content select="[title-actions]"></ng-content>
    </div>
  </div>

  <div class="input" style="width: 100%;">
    <ng-content>
    </ng-content>
  </div>
</div>
